import { render, staticRenderFns } from "./RTKRuleWatchlist.vue?vue&type=template&id=53416ab0&"
import script from "./RTKRuleWatchlist.vue?vue&type=script&lang=js&"
export * from "./RTKRuleWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports